// extracted by mini-css-extract-plugin
module.exports = {"SlideObserver":"slide-observer_SlideObserver__VtP0F"};